import moment from 'moment'
const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm:ss'

export function makeOnlineExamData (data) {
  let returnData = {
    session_id: data.session_id,
    class_id: data.class_id,
    schedule_type: data.schedule_type,
    section_id: data.section_id ? data.section_id : null,
    instruction_id: data.instruction_id,
    name: data.name,
    description: data.description,
    date: moment(data.date, dateFormat),
    expire_date: moment(data.expire_date, dateFormat),
    start_time: moment(data.start_time, timeFormat),
    end_time: moment(data.end_time, timeFormat),
    duration: data.duration,
    type: data.type,
    pass_mark: data.pass_mark,
    full_mark: data.full_mark,
    shuffle: data.shuffle,
    after_exam: data.after_exam,
    category_result: data.category_result,
    status: data.status,
    publish_date: moment(data.publish_on),
    publish_time: moment(data.publish_on),
    declare_date: moment(data.declare_on),
    declare_time: moment(data.declare_on),
  }

  return returnData
}
